<template>
  <div class="equipment-unit">
    <div class="unit-img">
      <img :src="img" width="100%" height="100%"/>
    </div>
    <div class="unit-content">
      <p class="top">{{name}}</p>
      <p class="bottom"><span>有效期:</span><span>{{effecDate}}</span></p>
      <p class="type" :class="type.indexOf('¥') > -1 ? 'money' : ''">{{type}}</p>
      <p v-if="crowdfund==='true'" class="tipType"  :class="'money'">众筹设备首年免费</p>
    </div>
   <!--  <button class="btn" @click.stop="btnClick">删除设备</button> -->
  </div>
</template>
<script>
export default {
  name: 'ChannelUnit',
  props: {
    name: String,
    type: String,
    img: String,
    effecDate: String,
    crowdfund: Boolean
    // position: String
  },
  methods: {
    btnClick () {
      this.$emit('btnClick', this.index)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl';
  .equipment-unit
    width 345px;
    height 23.2vh;
    background #ffffff;
    rowCenter();
    position relative
    .unit-img
      width 77px;
      height 77px;
      border-radius: 6px
      overflow hidden
    .unit-content
      padding-left 14px;
      width calc(331px - 13.2vh)
      .top
        height 34px;
        line-height 34px;
        font-size 18px;
        color #333333;
        font-weight 600;
        min-width 0;
        ellipsis();
      .bottom
        line-height 16px
        font-size 13px;
        color #666666;
        padding-top 8px
        min-width 0;
      .type
        padding-top 4px
        height 18px;
        line-height 18px;
        font-size 15px;
        color #333333;
        font-weight 600;
        min-width 0;
        ellipsis();
      .tipType
        margin-top -18px
        margin-left 42px
        height 18px;
        line-height 18px;
        font-size 12px;
        color #333333;
        font-weight 600;
        min-width 0;
        ellipsis();
      .money
        color: #F10E0E
    .btn
      font-size 15px
      padding 5px
      background transparent
      color #334f5f
      position absolute
      z-index 2
      right 14px
      top 25px
</style>



// WEBPACK FOOTER //
// src/pages/ChannelDetail/components/ChannelUnit.vue